import { ChevronLeft } from "@mui/icons-material";
import { Button, Theme, useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

const ButtonGoBack = () => {
  const theme: Theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const [canGoBack, setCanGoBack] = useState(false);

  useEffect(() => {
    setCanGoBack(window.history.length > 1);
  }, []);

  if (!canGoBack || isMobile) {
    return null;
  }

  return (
    <Button
      variant="white"
      color="primary"
      startIcon={<ChevronLeft />}
      onClick={() => navigate(-1)}
    >
      Go Back
    </Button>
  );
};

export default ButtonGoBack;
